import { confirmAlert } from "react-confirm-alert";
import { HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";
import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { Button, Textarea } from '../Form';
import { FiEye } from 'react-icons/fi';
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { updateCita } from "../../redux/features/citasSlice";
import { useDispatch } from "react-redux";

const CommentsModal = ({closeModal, isOpen, title, dataCita}) => {
    const {
        register,
        setValue,
        getValues
    } = useForm();
    const dispatch = useDispatch();

    useEffect(() => {
        setValue("comentarios", dataCita?.comentarios);
    }, [dataCita]);
    
    const onUpdate = async (data) => {
        if (dataCita?.id) {
            data.id = dataCita.id;
            data.comentarios = getValues("comentarios");
            const newData = await dispatch(updateCita(data));
            if (newData.error) {
                toast.error(
                    "Ocurrio un error al actualizar la cita: " + newData.error,
                    { duration: 5000 }
                );
            } else {
                toast.success("Cita actualizada exitosamente!", { duration: 5000 });
            }
        }
    }

    return (
        <Modal
            closeModal={closeModal}
            isOpen={isOpen}
            title={title}
            width={'max-w-4xl'}
        >   
            {/* list of comments */}
            <div className="flex-col content-center gap-6 overflow-y-hidden">
                <div className="w-full overflow-y-scroll">
                    {
                        getValues("comentarios") !== "" ? 
                            getValues("comentarios") :
                        "No se encontraron comentarios de la cita"
                    }
                </div>
            </div>
            {/* table charts selecteds */}
            <div className="flex-col gap-6 overflow-x-hidden">
                <div className="w-full overflow-x-scroll">
                    <Textarea
                        color={true}
                        visible={true}
                        placeholder={"Comentar sobre la visita del paciente..."}
                        name="comentarios"
                        register={register("comentarios")}
                        setValue={setValue}
                        getValue={getValues}
                    
                    />
                </div>
            </div>

            {/* buttons */}
            <div className="flex w-full justify-end gap-2">
                <Button
                label="Cancelar"
                onClick={() => {
                    closeModal();
                }}
                />
                <Button
                    label="Guardar"
                    onClick={() => {
                        const comentarios = getValues("comentarios");
                        if (comentarios !== "") {
                            onUpdate({ id: dataCita.id, patient_id: dataCita.patient_id, comentarios });
                            closeModal();
                        } else {
                            toast.error("Debe agregar algun comentario!", {
                                duration: 5000,
                            });
                        }
                    }}
                />
            </div>
        </Modal>
    );
};
 
export default CommentsModal